import { FormControl, styled } from "@mui/material"

export const StyledFormControl = styled(FormControl)(() => ({
    breakInside: "avoid",
    width: "85%",
}))
